






















































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { env } from '@ivy/fts/envInfo/envInfo'
import MicroPage from '@ivy/fts/microPage/index.vue'
import * as MicroUtils from '../shop/utils'
import config from '@/config'
import showDiv from '@ivy/fts/showDiv'
import { uploadEvent } from '@/api/goods/statistics'
import * as weixin from '@ivy/fts/weixin'
import ModalWrap from '../../components/modal/index.vue'

@Component({
  components: {
    MicroPage,
    ModalWrap,
  },
  filters: {
    removeTrailingZeros(value) {
      const number = parseFloat(value)
      return number === Math.floor(number) ? Math.floor(number) : number
    },
  },
})
export default class OrderClaim extends Vue {
  //订单编号
  order_tid: any = null
  pageId: number = config.env === 'production' ? 372 : 433
  memId = 0
  needReceiverId: boolean = false
  swipeIndex: number = 0
  swiperSpeed: number = 800
  flag: boolean = true
  hasCollected: number = null
  showTipsModal: boolean = false
  address: any = {}
  turnResult: boolean = false
  result: string = ''
  successCoin: number = null
  bindContent: any = null
  bannerInfo: any = []
  toBeReceivedList: any = []
  toBeReceivedTotal: number = null
  channles: any = [
    { title: `视频号`, channel: `1` },
    { title: `抖音`, channel: `2` },
    { title: `小红书`, channel: `4` },
    { title: `有赞`, channel: `3` },
  ]
  selectedChannel: any = { title: `视频号`, channel: `1` }

  async created() {
    await env.init()
    this.order_tid = window.localStorage.getItem('orderclaim-tid')
    await uploadEvent.init()
    if (await env.getIsLogin()) {
      let info = await env.getInfo()
      this.memId =
        env.type === 'wx' ? info.logined.user.id : info.userInfo.memId
    } else {
      this.memId = 0
    }
    // uploadEvent.addStatistics({
    //   event_type: 'Exposure_OrderClaim',
    //   p1: new Date().format('YYYY-MM-DD hh:mm:ss'),
    //   p2: this.memId,
    // })
    // this.judgeNeedReceiverId()
    this.loadData()
  }
  async loadData() {
    this.setShare()
    this.getBanner()
    this.getCanReceiveCoin()
  }
  async getBanner() {
    let { data } = await this.$axios.post('/api/audios/homes/floors/banners', {
      position: 'order_conversion',
    })
    this.bannerInfo = data[0]
  }
  async getCanReceiveCoin() {
    // this.toBeReceivedList = [
    //   {
    //     balance: 100,
    //     order_time: '9.1'
    //   },
    //   {
    //     balance: 2000,
    //     order_time: '9.21'
    //   }
    // ]
    // this.toBeReceivedList.length = 4
    // this.toBeReceivedTotal = 550
    // return;
    const isLogin = await env.getIsLogin()
    if (!isLogin) return
    let { data } = await this.$axios.get(
      `/api/mobile/account/water/toBeReceived`
    )
    this.toBeReceivedList = data.list || []
    if (this.toBeReceivedList.length < 4 && this.toBeReceivedList.length > 0) {
      this.toBeReceivedList.length = 4
    }
    this.toBeReceivedTotal = data.total || 0
  }
  async judgeNeedReceiverId() {
    let { data } = await this.$axios.post(
      '/api/activity/h5Activity/anniversary8/calculateResult'
    )
    this.needReceiverId = Object.keys(data.received_goods || {}).length > 0
    this.hasCollected = data.receiver_id
    if (data.receiver_id) {
      let { data: address } = await this.$axios.get(
        '/api/activity/h5Activity/anniversary8/getReceiverInfoById',
        {
          params: {
            receiver_id: data.receiver_id,
          },
        }
      )
      this.address = address
    }

    if (this.needReceiverId && this.$route.query.receiver_id) {
      await this.$axios.post(
        '/api/activity/h5Activity/anniversary8/collectClaimOrderAddress',
        {
          receiver_id: this.$route.query.receiver_id,
        }
      )
      this.hasCollected = +this.$route.query.receiver_id
      if (this.hasCollected) {
        let { data: address } = await this.$axios.get(
          '/api/activity/h5Activity/anniversary8/getReceiverInfoById',
          {
            params: {
              receiver_id: this.hasCollected,
            },
          }
        )
        this.address = address
      }
    }
  }
  async setShare() {
    let link = window.location.href
    if (env.type === 'wx') {
      let options = {
        title: '订单换金币 兑精选好物',
        desc: '点击进入常爸订单兑金币赢好礼活动',
        // imgUrl: require('./images/img_share.png'),
        imgUrl:
          'http://exploiter-beta.oss-cn-beijing.aliyuncs.com/tools/upload/c7855fa2-b395-d7c3-6dc5-bc6ea6ae57b7.png',
        link: encodeURI(link),
      }
      await weixin.weixinShare(options)
    } else if (env.type === 'ivydad') {
      let options = {
        title: '订单换金币 兑精选好物',
        content: '点击进入常爸订单兑金币赢好礼活动',
        url: link,
        pic_url:
          'http://exploiter-beta.oss-cn-beijing.aliyuncs.com/tools/upload/c7855fa2-b395-d7c3-6dc5-bc6ea6ae57b7.png',
        audio_url: '',
        type: 'web',
      }
      await env.init()
      await env.shareInfo(options)
    }
  }
  //点击认领按钮
  async onClickTurn() {
    // uploadEvent.addStatistics({
    //   event_type: 'Click_OrderClaim_ClaimNow',
    //   p1: this.memId,
    // })
    if (this.order_tid) {
      window.localStorage.setItem('orderclaim-tid', this.order_tid)
    }
    const isLogin = await env.getIsLogin()
    if (!isLogin) {
      return await env.login()
    }
    if (!this.order_tid) {
      return this.$Toast('请先输入订单编号再认领哦~')
    }
    let { data } = await this.$axios.post(
      '/api/goods/shop/market/thirdOrderGold/saveUserOrderRelationForGold',
      {
        tid: this.order_tid,
        platform: this.selectedChannel.channel,
      },
      {
        disableAlert: true,
      }
    )
    if (data.code !== 'SUCCESS') {
      this.result = 'error'
      this.bindContent = data.content || data.message || ''
    } else {
      this.result = 'success'
      this.bindContent = data.content || data.message || ''
    }
    //清掉订单编号的存储
    this.order_tid = ''
    window.localStorage.removeItem('orderclaim-tid')
    this.turnResult = true
  }
  clickPopupOk() {
    this.turnResult = false
    this.loadData()
  }
  async onClickRecord() {
    // await uploadEvent.addStatistics({
    //   event_type: 'Click_PackagingTools_ClaimRecord',
    //   p1: this.memId,
    // })
    this.$router.push({
      path: '/conversion-record',
      query: {},
    })
  }
  async receivedCoin() {
    await this.$axios.post('/api/mobile/account/water/collectWater')
    this.getCanReceiveCoin()
    this.$Toast('领取成功~')
  }
  async goMycoin() {
    const isLogin = await env.getIsLogin()
    if (!isLogin) {
      return this.toLogin()
    }
    window.location.href = `${window.location.origin}/invitation/myWater`
  }

  async goPurchaseRecord() {
    const isLogin = await env.getIsLogin()
    if (!isLogin) {
      return this.toLogin()
    }
    window.location.href = `${window.location.origin}/goods/purchaseRecord`
  }

  async toLogin() {
    await env.init()
    // 如未登陆跳转登陆
    if (!(await env.getIsLogin())) {
      return await env.login()
    }
  }
  beforeChange(index) {
    this.flag = false
  }
  endChange(index) {
    this.flag = true
    this.swipeIndex = index
  }
  async skip(url) {
    if (!this.flag) {
      return
    }
    if (url.includes('h5')) {
      return (window.location.href = decodeURIComponent(
        url.replace('ivydadreadtool://h5?url=', '')
      ))
    } else {
      MicroUtils.goLink(url, env)
    }
  }
  goRecord() {
    this.$router.push({
      path: '/conversion-record',
      query: {},
    })
  }
  continueTurn() {
    this.turnResult = false
  }
  goCoinShop() {
    window.location.href = window.location.origin + '/invitation/coinmall'
  }
}
